import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import RegisteredIcon from '../../../../../../assets/images/warranty/warranty-registered-icon.png';
import { flattenObject } from '../../../shared/utils';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.a`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  margin-top: 1.5rem;
  padding: 0.5rem;
  text-decoration: none;
  width: 100%;
  text-align: center;

  :hover {
    color: #fff;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

const mapStateToProps = state => ({
  formData: state.formData,
  viaClaimForm: state.viaClaimForm,
  appData: state.appData,
  claimData: state.claimData,
});

const HomeownerStep16 = ({ viaClaimForm, appData, claimData }) => {
  const data = {
    registration_number: appData?.registration?.registration_number,
    ...claimData,
  };
  const flattenedData = flattenObject(data);
  const queryString = Object.keys(flattenedData)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(flattenedData[key])}`)
    .join('&');

  return (
    <StepWrapper>
      <Header>This warranty is now...</Header>
      <img src={RegisteredIcon} />
      <IntroMessage>
        We've sent you an email with all the details for your records. Thanks for being an Owens Corning Customer!
      </IntroMessage>
      {viaClaimForm ? (
        <NextButton title="Owenscorning" href={`/en-us/roofing/warranty/submit-claim?${queryString}`}>
          Click HERE to continue with your claim
        </NextButton>
      ) : (
        <Subscript title="Owenscorning" href="https://www.owenscorning.com/en-us/roofing/warranty">
          Back to OwensCorning.com
        </Subscript>
      )}
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep16);
